import { combineReducers } from "redux";
import auth from "src/pages/auth/reducer";
import { LOGOUT } from "./actions";
import commonReducer from "./common-reducer";

const appReducer = combineReducers({
  commonReducer: commonReducer,
  auth: auth,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
